import * as React from 'react';
import type { StudyFilterSectionBlockViewModel } from '../ViewModel/StudyFilterSectionBlockViewModel.csharp';
import { StudyFilterSection } from './Components/StudyFilterSection/StudyFilterSection';
import { mapFragments } from './Utils/studyFilterSectionBlockUtils';

export const StudyFilterSectionBlock: React.FC<StudyFilterSectionBlockViewModel> = props => {
    const {
        heading,
        fragments,
        sectionVariant,
        studyCardVariant,
        searchUrl,
        resultsSortOrder,
        initialResult,
        translations,
    } = props;

    return (
        <StudyFilterSection
            heading={heading}
            elements={mapFragments(fragments)}
            variant={sectionVariant}
            studyCardVariant={studyCardVariant}
            searchUrl={searchUrl}
            resultsSortOrder={resultsSortOrder}
            initialResult={initialResult}
            translations={translations}
        />
    );
};
